import { LoadGeneratorWebhook } from 'types/api/services/load-generator'

export enum WebhookState {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED'
}

export interface Webhook {
  createdBy: string
  createdAt: string // date
  description?: string
  identifier: string
  isPrivateNetwork?: boolean
  name: string
  state: WebhookState
  teamId: string
  triggerEvents: string[] // [ "INITIALIZING", "RUNNING", "FINISHED" ]
  type: string // TASK
  updatedBy: string // date
  updatedAt: string // date
  webhookEndpoint: LoadGeneratorWebhook
}
